// store/modules/usageModule.js
import { db } from "@/firebase";
import { doc, onSnapshot } from "firebase/firestore";

export default {
    namespaced: true,

    state: () => ({
        usage: null,
        unsubscribe: null
    }),

    getters: {
        getUsage: (state) => state.usage
    },

    mutations: {
        SET_USAGE(state, payload) {
            state.usage = payload;
        },
        SET_UNSUB(state, fn) {
            state.unsubscribe = fn;
        }
    },

    actions: {
        async loadUsage({ commit }, pageId) {
            try {
                const res = await axios.get(
                    `${process.env.VUE_APP_BACKEND_URL}/api/subscription/usageLogs/${pageId}`
                );


                commit("SET_USAGE", {
                    ...res.data.data,
                });


                return { error: false };

            } catch (err) {
                console.error("loadPageInfo:", err.response?.data || err);
                commit("SET_USAGE", null);
                return { error: true };
            }
        },
        listenUsageRealtime({ commit, dispatch, state }, pageId) {

            if (state.unsubscribe) state.unsubscribe(); // close old listener

            const ref = doc(db, "usage", pageId);

            const unsub = onSnapshot(ref, (snap) => {
                if (snap.exists()) {
                    const data = snap.data();
                    commit("SET_USAGE", data);

                    // ระหว่างที่ usage เปลี่ยน → ให้โหลด subscription ใหม่อัตโนมัติ
                    dispatch("subscriptionModule/loadSubscription", pageId, { root: true });
                }
            });

            commit("SET_UNSUB", unsub);
        },
    }
};
